export default __webpack_public_path__ + "static/media/accounts.1abf9cec.svg";